import axios from 'axios'

// FIXME Should be in config..?
const MAXIMUM_PAGE_SIZE = 1000

const state = {
  response: [],
  resultCount: 0,
  isBusy: false
}

const mutations = {
  UPDATE_RESPONSE (state, payload) {
    state.response = payload.response
    state.resultCount = payload.resultCount
  },
  UPDATE_BUSY (state, payload) {
    state.isBusy = payload
  }
}

const actions = {
  clear ({ commit }) {
    commit('UPDATE_RESPONSE', { response: [], resultCount: 0 })
  },
  getAllPaginated ({ dispatch }, params) {
    return dispatch('getPaginated', {
      ...params,
      pageSize: MAXIMUM_PAGE_SIZE
    })
  },
  getPaginated ({ commit }, params) {
    commit('UPDATE_BUSY', true)

    return axios.get(process.env.VUE_APP_INTERNAL_API_BASEURL + '/license/usages/', { params: params })
      .then((response) => {
        commit('UPDATE_RESPONSE', response.data)
      })
      .catch((error) => {
        commit('UPDATE_RESPONSE', { response: [], resultCount: 0 })
        throw error
      })
      .finally(() => {
        commit('UPDATE_BUSY', false)
      })
  }
}

const getters = {
  response: state => state.response,
  resultCount: state => state.resultCount,
  isBusy: state => state.isBusy
}

const licenseUsages = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default licenseUsages
